export enum ResultsOptionalColumn {
  Nationality = 'nationality',
  Club = 'club',
  CzechRegistrationId = 'czechRegistrationId',
}

export type TournamentId = string

export type FlightSize = 2 | 3

export type Tournament = {
  // TODO incomplete definition
  id: TournamentId
  rounds: number
  finalRound: boolean
  teamsEnabled: boolean
  flightSize: FlightSize
  playersInFinalRound?: number
  defaultInterval?: number
  hashedPin: string
  orderByDifferent: boolean
  country: string
  dateFrom: string
  dateTo: string
  name: string
  shortName?: string
  venue: string
  notes?: string
  screenResultsOptionalColumns?: ResultsOptionalColumn[]
  printResultsOptionalColumns?: ResultsOptionalColumn[]
  public: boolean
  categoriesCloseAfterFinal: boolean
  championshipId?: string
}



// WEBPACK FOOTER //
// ./src/schemas/Tournament.ts